import { UserProfile } from 'fitbeat.gym-core';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonTypes } from '../components';
import { defaultScale } from '../utils/scaling';
import {
  IStrengthResult,
  selectStrengthAssessmentResultsAfterAssessment,
} from './selectors';
import { StrengthSummary } from './StrengthSummary';

interface IProps {
  userProfile: UserProfile;
  getNextStep(): void;
}

interface IStateProps {
  results: IStrengthResult[];
}

export const CompleteAssessmentComponent: React.FC<IProps & IStateProps> = ({
  results,
  getNextStep,
  userProfile,
}) => {
  return (
    <View style={styles.container}>
      <StrengthSummary results={results} gender={userProfile.gender}/>
      <Button
        title={'Recalibrate'}
        onPress={() => {
          getNextStep();
        }}
        containerStyle={styles.buttonContainer}
        buttonType={ButtonTypes.TRANSPARENT}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonContainer: {
    marginHorizontal: defaultScale(15),
  },
  imageContainer: {
    marginVertical: defaultScale(30),
    flex: 1,
  },
});

const mapStateToProps = (state, ownProps) => {
  return {
    results: selectStrengthAssessmentResultsAfterAssessment(state, ownProps.userProfile),
  };
};
export const CompleteAssessment: React.FC<IProps> = connect<IStateProps>(
  mapStateToProps,
)(CompleteAssessmentComponent);
